import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import emptyFunction from 'react-utils/emptyFunction';
import UIBox from 'UIComponents/layout/UIBox';
import { SubscriptionStatus } from 'commerce-subscription-lib/public/types';
import { isNumeric } from 'commerce-subscription-lib/public/utilities';
import { SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { useHasBillingWizardGate } from '../hooks/useHasGate';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const alwaysUndefined = emptyFunction.thatReturns(undefined);
function SubscriptionUpdatedMessage({
  isPaused,
  lastModifiedDate,
  pausedTimestamp
}) {
  return isPaused ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    "data-test-id": "subscription-properties:paused-date",
    className: "m-left-4",
    message: "subscriptions.SubscriptionProperties.pausedLabel",
    options: {
      formattedDate: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: pausedTimestamp,
        format: "ll"
      })
    }
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    "data-test-id": "subscription-properties:last-modified-date",
    className: "m-left-4",
    message: "subscriptions.SubscriptionProperties.lastModifiedLabel",
    options: {
      formattedDate: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: lastModifiedDate,
        format: "ll"
      })
    }
  });
}
export function SubscriptionProperties({
  lastModifiedDate,
  upcomingLineItems,
  objectId,
  status
}) {
  var _upcomingLineItems$le;
  const hasLastModifiedDate = isNumeric(lastModifiedDate);
  const isPaused = status.value === SubscriptionStatus.Paused;
  const hasModifiedLineItems = ((_upcomingLineItems$le = upcomingLineItems === null || upcomingLineItems === void 0 ? void 0 : upcomingLineItems.length) !== null && _upcomingLineItems$le !== void 0 ? _upcomingLineItems$le : 0) > 0;
  const showHasUpcomingChangesMessage = status.value !== SubscriptionStatus.Canceled && !isPaused && hasLastModifiedDate && hasModifiedLineItems;
  const showSubscriptionUpdatedMessage = hasLastModifiedDate || isPaused;
  const hasBillingWizardGate = useHasBillingWizardGate();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [status && /*#__PURE__*/_jsx(UIBox, {
      className: "m-top-2 m-left-4",
      "data-test-id": "subscription-properties:status",
      children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
        objectTypeId: SUBSCRIPTION_TYPE_ID,
        objectId: objectId,
        property: status.definition,
        value: status.value,
        getDraftValue: alwaysUndefined,
        getSavedValue: alwaysUndefined
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      children: showSubscriptionUpdatedMessage && /*#__PURE__*/_jsx(SubscriptionUpdatedMessage, {
        isPaused: isPaused,
        lastModifiedDate: lastModifiedDate,
        pausedTimestamp: status.timestamp
      })
    }), showHasUpcomingChangesMessage && /*#__PURE__*/_jsx(UIBox, {
      className: "m-left-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: hasBillingWizardGate ? 'subscriptions.SubscriptionProperties.editsForNextBilling' : 'subscriptions.SubscriptionProperties.editsForNextPayment',
        "data-test-id": "subscription-properties:upcoming-changes"
      })
    })]
  });
}